import Component from "../component.abstract";
import providers from "./providers.json";

export default class EmailSuggest extends Component {
    private dropdown: HTMLUListElement;
    private inputElement: HTMLInputElement;

    constructor(
        private props: unknown,
        element: HTMLInputElement
    ) {
        super(props, element);

        this.inputElement = <HTMLInputElement> this.element;
    }

    mounted(): void {
        // Create the dropdown list
        const displayAfter: HTMLElement = this.element;
        this.dropdown = document.createElement("ul");
        this.dropdown.classList.add("email-suggestions");

        // Add list elements
        providers.forEach((provider: string) => {
            const li: HTMLLIElement = document.createElement("li");
            li.setAttribute("data-value", provider);

            // Update value on click
            li.addEventListener("click", () => {
                this.inputElement.value = li.innerText;
                this.element.dispatchEvent(new Event("change"));
                this.element.dispatchEvent(new Event("blur"));

                this.toggleDropdown(false);
            });

            this.dropdown.appendChild(li);
        });
        displayAfter.parentNode.insertBefore(this.dropdown, displayAfter.nextSibling);

        // Listen to input changes
        this.element.addEventListener("keyup", this.onChange.bind(this));

        // Close dropdown on click outside
        window.addEventListener("click", (event: Event) => {
            if ((<HTMLElement> event.target).closest(".email-suggestions") !== this.dropdown) {
                this.toggleDropdown(false);
            }
        });
    }

    onChange(): void {
        let display = false;

        if (this.inputElement.value) {
            // Look for the text after the first @
            const value: Array<string> = this.inputElement.value.split(/@(.+)/);
            if (value.length > 1) {
                const entry: string = value[1];
                if (entry.length >= 1) {
                    const lis: NodeListOf<HTMLLIElement> = this.dropdown.querySelectorAll("li");
                    lis.forEach((li: HTMLLIElement) => {
                        // Get the providers that start with the entry
                        const provider = li.getAttribute("data-value");
                        if (provider.indexOf(entry) === 0) {
                            // Update li text and show it
                            li.innerHTML = 
                                "<b>" + value[0] + "@" + entry + "</b>" + provider.replace(entry, "");

                                li.classList.remove("hide");
                            display = true;
                        } else {
                            li.classList.add("hide");
                        }
                    });
                }
            }
        }

        // Open the dropdown if there's at least a suggestion
        this.toggleDropdown(display);
    }

    toggleDropdown(open: boolean) : void {
        this.dropdown.classList.toggle("opened", open);
    }
}